var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFundingInactive(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 48,
    viewBox: "0 0 49 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.78721 7.23245C7.25375 7.08951 6.70541 7.40609 6.56247 7.93956L0.868451 29.1899C0.725509 29.7234 1.04209 30.2717 1.57556 30.4147L40.2126 40.7674C40.7461 40.9104 41.2944 40.5938 41.4373 40.0603L47.1314 18.81C47.2743 18.2765 46.9577 17.7282 46.4242 17.5852L7.78721 7.23245ZM31.7273 26.0705C30.5838 30.3382 26.1971 32.8708 21.9293 31.7273C17.6616 30.5838 15.1289 26.1971 16.2725 21.9294C17.416 17.6616 21.8027 15.129 26.0704 16.2725C30.3382 17.416 32.8708 21.8027 31.7273 26.0705Z",
    fill: "#334E68"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 12C3.44772 12 3 12.4477 3 13V35C3 35.5523 3.44772 36 4 36H44C44.5523 36 45 35.5523 45 35V13C45 12.4477 44.5523 12 44 12H4ZM32 24C32 28.4183 28.4183 32 24 32C19.5817 32 16 28.4183 16 24C16 19.5817 19.5817 16 24 16C28.4183 16 32 19.5817 32 24ZM24 28C26.2091 28 28 26.2091 28 24C28 21.7909 26.2091 20 24 20C21.7909 20 20 21.7909 20 24C20 26.2091 21.7909 28 24 28Z",
    fill: "#334E68"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFundingInactive);
export default __webpack_public_path__ + "static/media/funding-inactive.2fe9c0a6dd4b1ec6cbeddc78beb0ff68.svg";
export { ForwardRef as ReactComponent };